export default {"src":"/_next/static/media/hamburger.a0c4fff3.svg","height":18,"width":25,"blurWidth":0,"blurHeight":0};